<template>
  <div class="gamePage">
    <q-card flat>
      <div class="tabs-continer" style="max-width: 600px">
        <q-tabs
          v-model="tab"
          class="text-grey"
          align="justify"
          narrow-indicator
        >
          <q-tab name="regular" label="Regular" />
          <q-tab name="super" label="Zero 1 super" />
          <q-tab name="virtual-2022" label="Virtual 2022" />
          <q-tab name="wro-2023" label="WRO 2023" />
        </q-tabs>
      </div>

      <q-separator size="1px"></q-separator>

      <q-tab-panels v-model="tab" animated>
        <q-tab-panel name="regular">
          <Regular
            v-if="userAge"
            :userAge="userAge"
            :userData="userData"
          ></Regular>
        </q-tab-panel>
        <q-tab-panel name="super">
          <super v-if="userAge" :userAge="userAge" :userData="userData"></super>
        </q-tab-panel>
        <q-tab-panel name="virtual-2022">
          <virtual-2022
            v-if="userAge"
            :userAge="userAge"
            :userData="userData"
          ></virtual-2022>
        </q-tab-panel>
        <q-tab-panel name="wro-2023">
          <WRO2023
            v-if="userAge"
            :userAge="userAge"
            :userData="userData"
          ></WRO2023>
        </q-tab-panel>
      </q-tab-panels>
      <!-- <div class="q-pa-md">
        <q-table title="" :data="rows" :columns="columns" row-key="fat" />
      </div> -->
    </q-card>
  </div>
</template>


<script>
import Regular from "@/components/user/GamePage/Regular";
import Super from "@/components/user/GamePage/Super";
import Virtual2022 from "@/components/user/GamePage/Virtual2022";
import WRO2023 from "@/components/user/GamePage/WRO2023";

export default {
  components: { Regular, Super, Virtual2022, WRO2023 },
  data() {
    return {
      tab: "regular",
      userAge: null,
      userData: null,
      columns: [
        { name: "score", align: 'left', label: "Score", field: "score", sortable: false },
        { name: "time", align: 'left', label: "Time", field: "time", sortable: false },
      ],
      rows: [
        {
          score: 6.0,
          time: 24,
        },
        {
          score: 9.0,
          time: 37,
        }
      ],
    };
  },
  mounted() {
    this.$API.general.getUSerType().then((response) => {
      this.userAge = response;
    });
    this.$API.userProfile
      .getProfile()
      .then((response) => {
        this.userData = response.data.data;
      })
      .catch((err) => {
        // make log out if something is worng or token is expierd
        if (err.response.data.status === false) {
          this.logOut();
        }
      });
  },
};
</script>

<style>
.back-btn.the-button {
  margin: 0 0 15px 10px !important;
}

.game-card-wrapper {
  margin: 0 -15px;
}

.game-card-col {
  padding: 0 15px;
  margin-bottom: 40px;
}

.fx-size-3 {
  width: 31.333% !important;
}

.fx-size-2 {
  width: 48% !important;
}

.game-card {
  background: #ffffff;
  height: 100%;
  text-align: center;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.16);
  position: relative;
  padding-bottom: 41.5px;
}

.game-card .card-game-holder {
  padding: 0px 10px;
}

.game-card .card-game-img {
  text-align: center;
  margin-bottom: 20px;
}

.game-card .download {
  font-size: 11px;
  text-align: center;
  margin: 15px 0px;
  cursor: pointer;
}

.card-game-img img {
  height: 147px;
  width: auto;
  object-fit: fill;
}

.card-game-text {
  text-align: left;
}

.card-game-text p:nth-child(1) {
  font-weight: 500;
  margin-bottom: 12px !important;
  text-transform: capitalize;
}

.card-game-text p:nth-child(2) {
  font-size: 0.75rem;
  color: var(--secondaryColors);
}

.card-button {
  position: absolute;
  left: calc(50% - 65px);
  bottom: -21.5px;
}

.the-button {
  margin: 0 !important;
}
</style>


